module.exports = __webpack_public_path__ + "img/sc-video-bg.90aaa3c5.png";